import Emp900ComprobantesPage from './Emp900ComprobantesPage'

export default function Emp900RemitosPage() {
  return <Emp900ComprobantesPage tipo="remito" />
}
